import SecurityRepository from './securityRepository'
import CartRepository from './cartRepository'

const repositories = {
  security: SecurityRepository,
  cart: CartRepository
}

export const RepositoryFactory = {
  get: name => repositories[name]
}
